import { createApp } from 'vue'
import App from './SocialRelief.vue'

createApp(App).mount('#app-social-relief')
